import { getECharts } from '@/lib/utils/echarts';
import { useConfigProvider } from '@/context/ConfigProvider';

// 获取ECharts实例
const echarts = getECharts();

export const GetEchartsOption = (type: string) => {
  const { isMobile } = useConfigProvider();

  let item: any = {
    first: {
      yname: 'Follower Over Time',
      colorLine: '#3AC76F',
      colorShadow: '#E0F7EC',
      left: '50px',
    },
    second: {
      yname: 'Daily New Followers',
      colorLine: '#EA5455',
      colorShadow: '#FBE1E2',
      left: '50px',
    },
    thired: {
      yname: 'Following Over Time',
      colorLine: '#8785FF',
      colorShadow: '#EBEBFF',
      left: '50px',
    },
  };

  return {
    tooltip: {
      trigger: 'axis',
      padding: [10, 20],
      // name:'',
      axisPointer: { type: 'shadow' },
      backgroundColor: 'rgb(255,255,255)',
      extraCssText: 'box-shadow: 0px 2px 12px 0px rgba(96,129,255,0.2)',
      textStyle: {
        color: '#666666',
      },
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      axisLabel: {
        margin: 20,
        color: '#D6D5D7',
        show: true,
      },
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      data: ['120', '220', '200', '231', '273', '294', '220', '218', '220', '200', '231', '273', '294', '220', '218'],
    },
    yAxis: {
      type: 'value',
      nameGap: 30,
      nameTextStyle: {
        fontWeight: '800',
        color: '#000000',
        fontSize: 18,
      },
      axisLabel: {
        margin: 20,
        color: '#D6D5D7',

        formatter: function (value: any) {
          // 如果数值大于等于1000，则除以1000并添加'k'后缀
          if (Math.abs(value) >= 1000) {
            return parseFloat((value / 1000).toLocaleString()) + 'k';
          } else {
            return value;
          }
        },
      },
      boundaryGap: [0, '30%'],
    },
    grid: {
      left: isMobile ? item[type].left : '8%',
      right: '4%',
      bottom: isMobile ? '22%' : '12%',
      top: '8%',
    },

    series: [
      {
        type: 'line',
        smooth: 0.3,
        symbol: 'none',
        color: item[type].colorLine,
        lineStyle: {
          color: item[type].colorLine,
          width: 3,
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: item[type].colorLine,
            },
            {
              offset: 1,
              color: item[type].colorShadow,
            },
          ]),
        },
        data: [120, 220, 200, 231, 273, 294, 220, 218, 220, 200, 231, 273, 294, 220, 218],
      },
    ],
  };
};
